import { Component } from '@angular/core';

@Component({
    selector: 'app-case-studies',
    templateUrl: './case-studies.component.html',
    styleUrls: ['./case-studies.component.scss'],
    standalone: false
})
export class CaseStudiesComponent {

}
